export default {
  state: {
    channelTotalUnread:0,
    currentLeftClick: null,
    splitScreenClick:null,
    //记录GIS地图当前点击的界面
    mapClick: null,
    allChatList:[],
    //是否需要重新拉取左侧的会话。
    needToGet:null,
    //判断当前是否在频道会话界面
    pageInChannel:true,
    overTimer: null
  },
  mutations: {
    setCurrentLeftClick(state, currentLeftClick) {
      state.currentLeftClick = currentLeftClick
    },
    setAllChatList(state, allChatList) {
      state.allChatList = allChatList
    },
    setChannelTotalUnread(state, channelTotalUnread) {
      if (channelTotalUnread < 0) {
        state.channelTotalUnread = state.allChatList.reduce((ac, item) => ac + item.unread, 0)
        return
      }
      state.channelTotalUnread = channelTotalUnread
    },
    setPageInChannel(state, pageInChannel) {
      state.pageInChannel = pageInChannel
    },
    setMapClick(state, mapClick) {
      state.mapClick = mapClick
    },
    setSplitScreenClick(state, splitScreenClick) {
      state.splitScreenClick = splitScreenClick
    },
    setNeedToGet(state, needToGet) {
      state.needToGet = needToGet
    },
  },
  actions:{
    addChatMsg({commit,state},jsonObject){
      let openId = jsonObject.openId
      if (!openId || state.allChatList.length == 0) {
        return
      }
      let chats = state.allChatList.filter(chat => chat.openId == openId)
      if (chats.length <= 0) {
        return
      }
      let chat = chats[0]
      chat.messageList = chat.messageList ? chat.messageList : []
      chat.messageList.push(jsonObject)
    },
    updateChatFileMsg({commit,state},jsonObject){
      //更新上传文件的消息
      let openId = jsonObject.openId
      if (!openId || state.allChatList.length == 0 || !jsonObject.tick) {
        return
      }
      let chats = state.allChatList.filter(chat => chat.openId == openId)
      if (chats.length <= 0) {
        return
      }
      let messages = chats[0].messageList
      if (messages.length == 0) {
        return
      }
      for (let i = 0; i < messages.length; i++) {
        let msg = messages[i]
        if (msg.tick == jsonObject.tick){
          Object.assign(msg, jsonObject)
          return
        }
      }

    },
    chatMessage({commit,state}, jsonObject) {
      if (!jsonObject) {
        return null
      }
      //对应数据的count要增加。
      let flag = false;
      for (let i = 0; i < state.allChatList.length; i++) {
        let chat = state.allChatList[i]
        if((jsonObject.openId === chat.openId)){
          flag = true;
          //把新消息刷新到左侧列表的最新一条，同时左侧未读数+1
          if((!state.pageInChannel || !state.currentLeftClick || state.currentLeftClick.openId !== jsonObject.openId)
              && (!state.mapClick || state.mapClick.openId !== jsonObject.openId)
            && (!state.splitScreenClick || state.splitScreenClick.openId !== jsonObject.openId) ){
            chat.unread = parseInt(chat.unread) + 1;
            //把总未读数+1
            state.channelTotalUnread ++ ;
            chat.needToSendRead = "0";
          }else{
            chat.needToSendRead = "1";
          }
          chat.sendName = jsonObject.sendName;
          chat.fileName = jsonObject.fileName;
          chat.fileSize = jsonObject.fileSize;
          chat.filePath = jsonObject.filePath;
          chat.fullFilePath = jsonObject.fullFilePath;
          chat.content = jsonObject.content;
          chat.sendTime = jsonObject.sendTime;
          chat.msgType = jsonObject.msgType;
          chat.sendId = jsonObject.sendId;
          chat.sendUserId = jsonObject.sendId;
          chat.sendSip = jsonObject.sendSip;
          chat.tipType = jsonObject.tipType;
          chat.tip = jsonObject.tip;
          chat.msgId = jsonObject.msgId;
          chat.tick = jsonObject.tick
          if(chat.haveSearchHistory === "1"){
            //拼接消息列。放入中间message消息数组中
            let list = {
              sendName:jsonObject.sendName,
              content:jsonObject.content,
              tip:jsonObject.tip,
              tipType:jsonObject.tipType,
              sendId:jsonObject.sendId,
              msgType:jsonObject.msgType,
              sendTime:jsonObject.sendTime,
              filePath:jsonObject.filePath,
              fullFilePath:jsonObject.fullFilePath,
              fileName:jsonObject.fileName,
              fileSize:jsonObject.fileSize,
              msgId:jsonObject.msgId,
              tick:jsonObject.tick,
              sendSip:jsonObject.sendSip,
              sending:false
            }
            chat.messageList = chat.messageList ? chat.messageList : [];
            //查询已存在的，且是发送中的
            if (chat.messageList.length > 0) {
              let sending = chat.messageList.filter(msg=>msg.tick==jsonObject.tick && msg.sending)
              if (sending.length > 0) {
                chat.messageList.remove(sending[0])
              }
            }
            chat.messageList.push(list);
            //如果当前选中的对象是新发消息的，则同时刷新一下。
            if(state.currentLeftClick.openId === jsonObject.openId){
              state.currentLeftClick = chat;
            }
          }
        }
      }
      if(!flag){
        //把总未读数+1
        state.channelTotalUnread ++ ;
      }
    },
    reloadOneSession({commit,state}, jsonObject){
      let openId = jsonObject.sessionId;
      for (let i = 0; i < state.allChatList.length; i++) {
        if(openId === state.allChatList[i].openId) {
          let newList = JSON.parse(JSON.stringify(state.allChatList[i]));
          if('1' === jsonObject.changeType || '2' === jsonObject.changeType){
            newList.memberList = jsonObject.newMemberList;
            state.allChatList[i].memberList = jsonObject.newMemberList;
          }
          if('0' === jsonObject.changeType || '2' === jsonObject.changeType){
            newList.groupName = jsonObject.sessionName;
            state.allChatList[i].groupName = jsonObject.sessionName;
          }
          if(state.currentLeftClick.openId === openId){
            commit('setCurrentLeftClick', newList)
          }
        }
      }
    },
    getParamByOpenId({commit,state},openId){
      return new Promise((resolve, reject) => {
        for (let i = 0; i < state.allChatList.length; i++) {
          if(openId === state.allChatList[i].openId) {
            resolve(state.allChatList[i])
          }
        }
      })
    },
    startMsgOverTimer({commit, state}) {
      if (!state.overTimer) {
        clearInterval(state.overTimer)
        delete state.overTimer
        state.overTimer = null
      }
      console.log('Start IM message over timer!!!')
      state.overTimer = setInterval(()=>{
        if (state.allChatList.length <= 0) {
          return
        }
        let now = new Date().getTime()
        state.allChatList.forEach(chat=>{
          if (chat.messageList && chat.messageList.length > 0) {
            let sendingMsgs = chat.messageList.filter(msg => msg.sending && msg.timestamp && ((now - msg.timestamp) > 10000))
            if (sendingMsgs && sendingMsgs.length > 0) {
              sendingMsgs.forEach(msg=>{
                msg.fail = true
                msg.sending = false
              })
            }
          }
        })
      },2000)

    },
    stopMsgOverTimer({commit,state}) {
      if (!state.overTimer) {
        console.log('Stop IM message over timer!!!')
        clearInterval(state.overTimer)
        delete state.overTimer
        state.overTimer = null
      }
    }
  },
  strict: true
}



// WEBPACK FOOTER //
// ./src/store/module/chatStore.js